import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import CreditCardIcon from "@mui/icons-material/CreditCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import { Button, Chip, DialogActions, DialogContent, Paper, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Tooltip from "@mui/material/Tooltip";
import { ROUTE_NUMBER_COUNT } from "@/constants/config";
import img from "@/components/IntroAllRoutes/img.png";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

const PriceGuarantee = (props: {
  useWhere?: "routes" | "all-routes";
  onRouteRequest?: (v: boolean) => void;
}) => {
  const bgBlack = "https://img.awardtool-api.com/img/all_routes_black.png";
  const bgWhite = "https://img.awardtool-api.com/img/all_routes_white.png";

  const { useWhere = "route", onRouteRequest } = props;

  const theme = useThemeData();
  const { isPc } = usePlatform();

  const [visible, setVisible] = useState(false);

  const navigate = useNavigate();

  return (
    <Paper
      elevation={1}
      className="!rounded-[4px]"
      style={{
        backgroundColor: theme.isDarkMode ? "#202124" : "#f1f3fb",
        marginLeft: "10px",
        marginRight: "10px",
      }}
    >
      <div className="flex items-center justify-between h-[70px]">
        <div className="pl-[20px] flex items-center">
          <div className="w-[30px] h-[30px] mr-[10px]">
            <CalendarMonthIcon color="primary" />
          </div>
          <div>
            <div className="flex items-center justify-between md:justify-start">
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                {isPc ? "Calendar View for " + ROUTE_NUMBER_COUNT.toLocaleString() + "+ Panorama Routes" : "Panorama Routes"}
              </Typography>

              {useWhere === "routes" ? (
                <Button
                  size="small"
                  variant="outlined"
                  className="!ml-[15px]"
                  onClick={() => navigate("/all-routes")}
                >
                  All Routes
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<ThumbUpOffAltIcon />}
                  className="!ml-[15px]"
                  onClick={() => {
                    if (onRouteRequest) {
                      onRouteRequest(true);
                    }
                  }}
                >
                  Request Route
                </Button>
              )}
            </div>
            <Typography className="inline flex items-center">
              {isPc
                ? <>Instantly access<Typography className="ml-[5px] mr-[5px]" sx={{
                  fontWeight: "bold",
                  marginLeft: "4px",
                  marginRight: "4px",
                }}> one year</Typography> of availability for your favorite program routes.</>
                : "Access yearly data for " + ROUTE_NUMBER_COUNT / 1000 + "K+ routes."}
              <Tooltip
                sx={{ size: 10 }}
                title={"We monitor " + ROUTE_NUMBER_COUNT.toLocaleString() + "+ program routes to maximize your flexibility in finding award tickets. Everyone has the opportunity to vote for their preferred routes, and the most voted-for ones will soon become accessible to all. And you're able to search by region and countries."}
              >
                <InfoOutlinedIcon
                  onClick={() => {
                    if (!isPc) {
                      setVisible(true);
                    }
                  }}
                  sx={{ fontSize: 16, margin: "auto" }}
                />
              </Tooltip>
            </Typography>
          </div>
        </div>

        {isPc && <img className="h-[90%]" src={theme.isDarkMode ? bgBlack : bgWhite} alt="" />}

        <Dialog
          open={visible}
          onClose={() => setVisible(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={16}>
              {"We monitor " + ROUTE_NUMBER_COUNT.toLocaleString() + "+ program routes to maximize your flexibility in finding award tickets. Everyone has the opportunity to vote for their preferred routes, and the most voted-for ones will soon become accessible to all. And you're able to search by region and countries."}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVisible(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
};

export default PriceGuarantee;
